import { render, staticRenderFns } from "./MainVueApp.vue?vue&type=template&id=1c141c79&"
import script from "./MainVueApp.vue?vue&type=script&lang=js&"
export * from "./MainVueApp.vue?vue&type=script&lang=js&"
import style0 from "./MainVueApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainVueApp.vue"
export default component.exports